// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClearFormController from "./clear_form_controller"
application.register("clear-form", ClearFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)
